import { useT } from '@kmgestao/i18n';
import { Badge, PageIntroCard } from '@kmgestao/ui';

import { formatDateTime, type AiKpisSummary } from '../../../features/ai-analytics/index.js';

import { getDashboardHealthTone } from './dashboardTheme.js';

export interface DashboardHeroProps {
  summary: AiKpisSummary | undefined;
  generatedAt: string | undefined;
  periodDays: number;
}

export function DashboardHero({ summary, generatedAt, periodDays }: DashboardHeroProps) {
  const { t } = useT('dashboard');
  const healthTone = getDashboardHealthTone(summary);

  return (
    <PageIntroCard
      eyebrow={t('page.breadcrumb')}
      title={t('page.title')}
      description={t('page.subtitle')}
      meta={
        <>
          <Badge>{t('page.period', { days: periodDays })}</Badge>
          <Badge variant={toBadgeVariant(healthTone)}>{t(`hero.health.${healthTone}`)}</Badge>
          <Badge variant="outline">
            {generatedAt
              ? t('page.generatedAt', { date: formatDateTime(generatedAt) })
              : t('hero.footer.waiting')}
          </Badge>
        </>
      }
    >
      <p className="text-sm leading-6 text-muted-foreground">{t('hero.footer.base')}</p>
    </PageIntroCard>
  );
}

function toBadgeVariant(
  tone: 'success' | 'warning' | 'destructive',
): 'success' | 'secondary' | 'destructive' {
  if (tone === 'success') return 'success';
  if (tone === 'warning') return 'secondary';
  return 'destructive';
}
